import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Auth } from '../../../autentication/Auth';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { LimitsService } from '../limits.service';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AllPeriodsLimitType, LimitTipo, LimiteGeralModel } from '../models/limits';

@Component({
	selector: 'app-limits-other-limits',
	templateUrl: './other-limits.component.html',
	styleUrls: ['./other-limits.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class LimitsOtherLimitsComponent implements OnInit {

	listLimits: Array<AllPeriodsLimitType> = [];
	tefItem: AllPeriodsLimitType;
	boletoItem: AllPeriodsLimitType;
	convenioItem: AllPeriodsLimitType;
	accountType: any;

	constructor(private limitsService: LimitsService, public dialog: MatDialog, private router: Router) { }

	ngOnInit() {
		this.accountType = Auth.getInstance().getUser().accountType;
		this.load();
	}

	load(): void {
		this.limitsService.getDataLimits().subscribe(data => {

			this.listLimits = data[0];

			this.tefItem = this.listLimits.find(e => e.type === LimitTipo.TEF);
			this.convenioItem = this.listLimits.find(e => e.type === LimitTipo.CONVENIO);
			this.boletoItem = this.listLimits.find(e => e.type === LimitTipo.BOLETO);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.router.navigate(['/minha-conta/meu-pacote']);
		});
	}

	showTime(limit: LimiteGeralModel) {
		const startTime = limit.FaixaHorario.HorarioInicial;
		const endTime = limit.FaixaHorario.HorarioFinal;

		return `(${this.formatTime(startTime)} - ${this.formatTime(endTime)})`
	}

	limitAmountPerDay(limit: LimiteGeralModel) {
		const limitAmount = limit.LimitarValorPorDia;
		if (limitAmount) return limit.ValorPorDia;
		return "Ilimitado"
	}


	formatTime(time: string): string {
		const hours = parseInt((time).slice(0, 2), 10);
		const minutes = parseInt((time).slice(3, 5), 10);

		const minutesFormatted = minutes < 10 ? '0' + minutes.toString() : minutes.toString();

		if (minutes === 0) {
			return `${hours}h`;
		}

		return `${hours}:${minutesFormatted}h`;
	}

	showTefDailyLimitItem = (): boolean => Boolean(this.tefItem && this.tefItem.dailyLimit);

	showTefNightlyLimitItem = (): boolean => Boolean(this.tefItem && this.tefItem.nightlyLimit);

	showBoletoDailyItem = (): boolean => (this.boletoItem && !!this.boletoItem.dailyLimit);

	showBoletoNightlyItem = (): boolean => (this.boletoItem && !!this.boletoItem.nightlyLimit);

	showConvenioDailyItem = (): boolean => Boolean(this.convenioItem && this.convenioItem.dailyLimit);

	showConvenioNightlyItem = (): boolean => Boolean(this.convenioItem && this.convenioItem.nightlyLimit);
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limits/other-limits/other-limits.component.ts